"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../types");
const API = {
    profile: '/api/ac/v2/user/published/me',
    markUserEvent: '/api/ac/v2/user/published/markEvent',
    tutorial: '/api/ac/v2/user/published/tutorial',
    markTutorial: '/api/ac/v2/user/published/markTutorial'
};
class MerchantProfile {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getProfile() {
        const res = await this._httpClient.get(API.profile);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = {
            users: {
                [resBody.result]: {
                    _id: lodash_1.default.get(resBody, 'entities.user._id', null),
                    email: lodash_1.default.get(resBody, 'entities.user.email', null),
                    username: lodash_1.default.get(resBody, 'entities.user.username', null),
                    avatar: lodash_1.default.get(resBody, 'entities.user.avatar', null),
                    status: lodash_1.default.get(resBody, 'entities.user.status', null),
                    tags: lodash_1.default.get(resBody, 'entities.user.tags', []),
                    systemRole: lodash_1.default.get(resBody, 'entities.user.systemRole', null),
                    serviceRole: lodash_1.default.get(resBody, 'entities.user.serviceRole', {}),
                    kybServiceRole: lodash_1.default.get(resBody, 'entities.user.kybServiceRole', {}),
                    hasCompleted: lodash_1.default.get(resBody, 'entities.user.hasCompleted', {}),
                    haveTwoFA: lodash_1.default.get(resBody, 'entities.user.haveTwoFA', false),
                    isSubscribeNewsLetter: lodash_1.default.get(resBody, 'entities.user.isSubscribeNewsLetter', false),
                },
            },
        };
        return data;
    }
    async markTutorialComplete() {
        await this._httpClient.put(API.markUserEvent, {
            eventName: types_1.MERCHANT_EVENT.VIEW_TUTORIAL,
        });
        return {
            result: null,
            entities: {},
        };
    }
    async getTutorial() {
        const res = await this._httpClient.get(API.tutorial);
        let data = {
            tutorialData: {},
            _version: "1"
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        let rawData = resBody.entities.tutorialData;
        if (!rawData) {
            return data;
        }
        data.tutorialData = rawData.data;
        data._version = rawData._version;
        return data;
    }
    async setTutorialData(tutorialData) {
        const res = await this._httpClient.put(API.markTutorial, tutorialData);
        let data = {
            tutorialData: {},
            _version: "1"
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        let rawData = resBody.entities.tutorialData;
        if (!rawData) {
            return data;
        }
        data.tutorialData = rawData.data;
        data._version = rawData._version;
        return data;
    }
}
exports.default = MerchantProfile;
